import type { UserDetails } from "@project/api";
import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { useIsAdmin } from "../../../hooks/router";

export const useNavigateUserLayout = () => {
  const navigate = useNavigate();

  return useCallback((user: UserDetails) => {
    const { currentProvider, currentAccount } = user;

    if (!currentProvider.emailVerified) {
      void navigate({ to: "/email-verification" });
    }
    else if (!currentAccount) {
      void navigate({ to: "/select-account" });
    }
  }, [navigate]);
};

export const useNavigateUserAuth = () => {
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();

  return useCallback((user: UserDetails) => {
    const { currentProvider, currentAccount } = user;

    if (!currentProvider.emailVerified) {
      void navigate({ to: "/email-verification" });
    }
    else if (!currentAccount) {
      void navigate({ to: "/select-account" });
    }
    else {
      if (isAdmin) {
        void navigate({ to: "/admin" });
      }
      else {
        void navigate({
          to: "/$accountName",
          params: { accountName: currentAccount.name },
        });
      }
    }
  }, [navigate, isAdmin]);
};
